import clsx from 'clsx';
import React from 'react';

import IconDeepResearchVertical from '@components/Images/DeepResearch/IconDeepResearchVertical';
import PaywallBanner from '@components/pages/AI/DeepResearch/Paywall/Banner';
import DeepResearchSuggested from '@components/pages/AI/DeepResearch/Suggested';
import { useAppContext } from '@contexts/AppContext';
import useEventTracking from '@hooks/useEventTracking';
import { IMGIX_URL } from '@src/env';
import { Page, TrackingLocation } from '@tracking';

import DeepResearchArticleSearch from '../ArticleSearch';

const Paywall = () => {
  const { initialCurrentUser } = useAppContext();

  const { Track } = useEventTracking({
    location: TrackingLocation.Paywall,
    page: Page.DeepResearchWelcome,
  });

  return (
    <Track>
      <main>
        <div className="mx-auto flex max-w-4xl flex-col items-center justify-center px-16 text-center">
          <IconDeepResearchVertical
            className="mt-0 h-56 w-[200px] xs:h-72 xs:w-[250px] sm:mt-24 sm:h-[85px] sm:w-[300px]"
            viewBox="0 0 120 34"
          />
          <video
            width="100%"
            height="auto"
            className="pointer-events-none mt-28 sm:mt-32"
            aria-label="Example questions being entered into TI Deep Research"
            autoPlay
            disablePictureInPicture
            loop
            muted
            playsInline
          >
            <source
              src={`${IMGIX_URL}/global/deep_research/paywall-search-bar-mobile.mp4`}
              media="(max-width: 479px)"
            />
            <source
              src={`${IMGIX_URL}/global/deep_research/paywall-search-bar-v3.mp4`}
              media="(min-width: 480px)"
            />
          </video>
          <p className="mb-0 mt-8 font-suisse-neue text-body-md font-normal xs:text-body-md sm:text-subheadline-sm">
            Accelerate your research with AI-powered answers grounded in over a decade of The
            Information’s trusted reporting, org charts and data &mdash; because AI is only as smart
            as the data it learns from.
          </p>
        </div>
        <PaywallBanner />
        <div
          className={clsx('mx-auto mt-72 px-16 sm:mt-64 sm:px-28', {
            'mb-72 md:mb-112': !initialCurrentUser?.is_subscriber,
          })}
        >
          <p className="mx-auto w-full max-w-[320px] text-center font-suisse-neue text-description-sm font-normal sm:max-w-none sm:text-body-lg md:mx-0 md:text-left">
            I am trained on The Information’s exclusive reporting and data. Try asking me to…
          </p>
          <DeepResearchSuggested disablePrompts={true} setSuggestedPrompt={null} />
        </div>
        {initialCurrentUser?.is_subscriber && <DeepResearchArticleSearch />}
      </main>
    </Track>
  );
};

export default Paywall;
